// src/pages/Performance.js
import React, { useEffect, useState } from "react";
import { fetchPerformance } from "../api";
import RingChart from "../components/RingChart";

const FILTERS = ["All subjects", "Quant", "Reasoning", "English", "GA & Banking"];

export default function Performance() {
  const [skills,  setSkills]  = useState([]);
  const [filter,  setFilter]  = useState("All subjects");
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");

  useEffect(() => {
    fetchPerformance()
      .then(d  => { setSkills(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /><span>Loading performance…</span></div>;

  const visible = filter === "All subjects" ? skills : skills.filter(s => s.subject === filter);

  function statusLabel(s) {
    if (s.accuracy >= 0.75) return "mastered";
    if (s.accuracy >= 0.50) return "improving";
    return "weak";
  }
  function accColor(a) {
    return a >= 0.75 ? "var(--green)" : a >= 0.50 ? "var(--amber)" : "var(--red)";
  }

  return (
    <div>
      <h1 className="page-title">Performance</h1>
      <p className="page-sub">Topic-level accuracy across all your practice sessions</p>

      {error && <div className="error-box">{error}</div>}

      {/* Filter pills */}
      <div className="filter-row">
        {FILTERS.map(f => (
          <button
            key={f}
            className={`filter-btn${filter === f ? " active" : ""}`}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Table */}
      {visible.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: "40px 20px" }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>📊</div>
          <p style={{ color: "var(--text-muted)", fontSize: 13 }}>
            No data for this subject yet. Start practising!
          </p>
        </div>
      ) : (
        <div className="perf-table">
          <div className="perf-hdr">
            <div />
            <div>Topic</div>
            <div style={{ textAlign: "center" }}>Attempts</div>
            <div style={{ textAlign: "center" }}>Correct</div>
            <div style={{ textAlign: "right" }}>Accuracy</div>
            <div style={{ textAlign: "center" }}>Status</div>
          </div>

          {visible.map((s, i) => {
            const pct    = Math.round(s.accuracy * 100);
            const status = statusLabel(s);
            return (
              <div className="perf-row" key={i}>
                {/* Ring */}
                <div><RingChart pct={pct} size={52} strokeWidth={5} /></div>

                {/* Topic */}
                <div style={{ paddingLeft: 6 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{s.topic}</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 1 }}>{s.subject}</div>
                </div>

                {/* Attempts */}
                <div style={{ textAlign: "center", fontSize: 13, fontWeight: 500 }}>
                  {s.attempts}
                </div>

                {/* Correct */}
                <div style={{ textAlign: "center", fontSize: 13, fontWeight: 500 }}>
                  {s.correct}
                </div>

                {/* Accuracy + bar */}
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: accColor(s.accuracy) }}>{pct}%</div>
                  <div style={{ height: 4, background: "var(--bg)", borderRadius: 2, width: 70, marginTop: 4, overflow: "hidden", marginLeft: "auto" }}>
                    <div style={{ height: "100%", width: `${pct}%`, background: accColor(s.accuracy), borderRadius: 2 }} />
                  </div>
                </div>

                {/* Status badge */}
                <div style={{ textAlign: "center" }}>
                  <span className={`badge badge-${status}`}>{status}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
